import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';
import { CourseCreateInput } from '@/types/courses';

export const useCourseCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CourseCreateInput | any) => {
      const res = await request.post('/course', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-list'] });
    }
  });
};

export const useCourseUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: Partial<CourseCreateInput> | any }) => {
      const res = await request.patch(`/course/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-list'] });
    }
  });
};

export const useCourseDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/course/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-list'] });
    }
  });
};
